function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.722 0v16.276M14.722 9.318l-7 7.309-7-7.309"
}));

function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.444,
    height: 18.073,
    viewBox: "0 0 15.444 18.073"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS40NDQiIGhlaWdodD0iMTguMDczIiB2aWV3Qm94PSIwIDAgMTUuNDQ0IDE4LjA3MyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE4Ljk3OCAtNDExLjUpIj48cGF0aCBkPSJNMCwwVjE2LjI3NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjYuNyA0MTEuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz48cGF0aCBkPSJNMzIuNTYsNDE5LjgxOGwtNyw3LjMwOS03LTcuMzA5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjE0IDEpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPgo=";
export { SvgDownArrow as ReactComponent };